import AdminNavBar from './AdminNavBar';
const Admin = () => {
	return (
		<AdminNavBar />
	)
};

export default Admin
